<app-expert-group-portal-header
  selectedNavItem="explorer"
  [expertGroupPortal]="expertGroupPortal"
></app-expert-group-portal-header>

<div class="container-full">
  <div class="columns">
    <div class="column pb-2">
      <iframe
        class="futures-explorer"
        [src]="iframeUrl"
        frameborder="0"
        width="100%"
        style="height: 750px"
      ></iframe>
    </div>
  </div>
</div>
